import { createSessionAccess } from './session-access-core';
import { env } from '@/platform/env';
export const sessionAccess = createSessionAccess({
  profileUrl: `${env.apiUrl.replace(/\/$/, '')}/profile/`,
  getToken: () => (typeof window === 'undefined' ? null : localStorage.getItem('auth_token')),
  clearSession: () => {
    localStorage.removeItem('auth_token');
  },
  loginPath: '/xac-thuc'
});
if (typeof window !== 'undefined') {
  const stop = sessionAccess.start();
  if (import.meta.hot) import.meta.hot.dispose(stop);
}
